import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { cceService } from "./cceService";
import { globalPrompt } from "@/components/message";
import { useGlobalModel, transPgToPagination } from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { ISearchPage } from "@/types/AppTypes";
import { ICceDetail, ICceSearchFields } from "./cceTypes";

export const useCceModel = createModel(function () {
	const { user: { shopCode }, setLoadingInfo } = useGlobalModel(({ user }) => [user]);
	/**
	 * 列表
	 */
	//列表数据源
	const [dataSource, setDataSource] = useState<ICceDetail[]>([]);
	//查询条件
	const [searchParam, setSearchParam] = useState<ICceSearchFields>({});
	//分页参数
	const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
	const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
	//表格多选code值
	const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
	const [loading, setLoading] = useState<boolean>(false);


	//列表查询
	const loadData = async (page: ISearchPage = initPgCfg, searchValue: ICceSearchFields = searchParam) => {
		setLoading(true);
		const searchParams = {
			shopCode,
			...searchValue,
			page: {
				pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
				pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
			}
		}
		let { retData } = await cceService.page(searchParams);
		const { records, ...pg } = retData;
		setPgCfg(transPgToPagination(pg));
		setDataSource(records);
		setLoading(false);
	}
	//设置搜索value
	const updateSearchParam = (updateParam: ICceSearchFields) => {
		setSearchParam({ ...searchParam, ...updateParam })
	}

	//重置搜索参数
	const resetSearchParam = () => {
		setSearchParam({});
		setSelectedRowKeys([]);
		loadData(initPgCfg, {});
	}

	//导出
	const exportCce = async (searchValue: ICceSearchFields = searchParam) => {
		setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
		try {
			const searchParams = {
				shopCode,
				...searchValue,
				singleCode: selectedRowKeys?.join(),
				pageSize: -1,
				pageNum: 1,
			};

			let result = await cceService.export(searchParams);
			result && setLoadingInfo({ loadingVisible: false, txt: "" });
			convertRes2Blob(result);
		} catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
	}

	//下载模板
	const downloadTpl = async () => {
		let result = await cceService.downloadTpl();
		convertRes2Blob(result);
	}

	//启用 禁用 api
	const disableCce = async (id: string) => {
		let { retData } = await cceService.disable(id);
		loadData()
		globalPrompt("message", { text: "作废成功", type: "success" })
	};

	return {
		/***field***/
		searchParam,
		dataSource,
		selectedRowKeys,
		pgCfg,
		loading,
		/***method***/
		setDataSource,
		setSelectedRowKeys,
		resetSearchParam,
		updateSearchParam,
		loadData,
		exportCce,
		downloadTpl,
		disableCce,
	}
});